import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { EditorInputField } from '../../../editor-container/editor-model';
import { ToggleSectionDirective } from '../theme-color-picker/toggle-section.directive';

@Component({
  selector: 'kve-text-color-picker',
  templateUrl: './text-color-picker.component.html',
  styleUrls: ['./text-color-picker.component.scss']
})
export class TextColorPickerComponent implements OnInit,AfterViewInit,OnChanges {
  @Input()field:EditorInputField;
  @ViewChild(ToggleSectionDirective) togglePickers;
  fieldName:string;

  primaryColor = '#8f9bb3';

  selectedOption = "preset";

  option;

  pickerOptions = [
    {label:"Presets",value:"preset", name:"presetOption",checked: "true"},
    {label:"Custom",value:"custom", name:"presetOption"}
  ]

  basicColors:string[] = [
    "#ffffff",
    "#f7f9fc",
    "#edf1f7",
    "#e4e9f2",
    "#c5cee0",
    "#8f9bb3",
    "#2e3a59",
    "#222b45",
    "#192038",
    "#151a30",
    "#101426"
  ]

  @Output() updateField: EventEmitter<any> = new EventEmitter<any>();

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["field"]){
      console.log(this.field)
    }
  }

  ngOnInit(): void {
  }
  ngAfterViewInit(): void {

  }

  changeComplete(e){}

  handleChangeComplete(e){}

  handleColorPick(e){
    console.log(e)
    console.log(this.field);
    this.field.value = e.color.hex;
    this.updateField.emit(this.field);
  }

  onChangeOption(e){
    console.log(e);
    this.field.value = e.color.hex;
    this.updateField.emit(this.field);
  }

}

  
